export type JSONData = any;

export enum AudioQuality {
    hi = '96k',
    mid = '48k',
    low = '24k',
}

export enum AudioFormat {
    m4a = 'm4a',
    ogg = 'ogg',
}
export enum ImageFormat {
    AVIF = 'avif',
    WEBP = 'webp'
}

export type Platform = 'desktop' | 'mobile';

export const PLATFORMS: Platform[] = ['desktop', 'mobile'];

export const PLATFORM_TYPE_MAP: [Platform, string][] = [
    ['desktop', 'D'],
    ['mobile', 'M']
];

export type ResourceBaseConf = {
    /**
     * Resource type.
     */
    type: string;
    /**
     * Resource find path.
     */
    path: string | string[];
    /**
     * Exclude resources.
     */
    pathExclude?: string[];
};

export type Resolution = {
    name: string;
    multiplayer: number;
};

export type AudioConfig = {
    format: AudioFormat;
    quality: AudioQuality;
};

export type MetaPackageInfo = {
    files: [name: string, size: number][];
    configs: string;
    imageResolution?: string;
    imageFormat?: ImageFormat;
    audioFormat?: AudioFormat;
    audioQuality?: AudioQuality;
};

export type MetaPackageSet = {
    priority: number;
    optional?: boolean;
    variants: MetaPackageInfo[];
};

export type Meta = Record<string, MetaPackageSet>;
export type ResourcesMetaFile = {
    audio: Meta;
    graphics: Meta;
};

export enum PackageType {
    all = 'all',
    audio = 'audio',
    allExceptAudio = 'allExceptAudio'
}

export type BinaryDataAudio = {
    names: string[];
    ext: AudioFormat;
    data: Buffer;
};

export type BinaryDataImage = {
    name: string;
    width: number;
    height: number;
    resolution: number;
    data: Buffer;
};

export type BinaryDataSpine = {
    name: string;
    data: JSONData;
};

export type BinaryDataBitmapFont = {
    name: string;
    data: string;
};

export type BinaryDataPackage = {
    img: BinaryDataImage[];
    audio: BinaryDataAudio[];
    spine: BinaryDataSpine[];
    bitmapFont: BinaryDataBitmapFont[];
};